import { Button, Dialog, DialogContent, Grid, IconButton, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import { postCliente, postClienteAgora } from '../../services/apis'; // Asegúrate de que esta función exista
import { AlertError } from '../../utils/componentes-utiles/AlertError';
import CancelIcon from '@mui/icons-material/Cancel';

export const FormCrearCliente = ({ open, setOpen }) => {
    const [cliente, setCliente] = useState({
        nombre: '',
        direccion: '',
        telefono: ''
    });

    const [errorAlert, setErrorAlert] = useState(false);
    const [erroRespues, setErroRespues] = useState(false);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setCliente(prev => ({ ...prev, [name]: value }));
        setErrorAlert(false);
    };

    const handleClose = () => {
        setOpen(false);
        setCliente({ nombre: '', direccion: '', telefono: '' });
    };

    const crearCliente = async (cliente) => {
        try {
            const response = await postClienteAgora(cliente);
            console.log(response.success);

            if (response.success) {
                handleClose();
            }
        } catch (error) {
            console.error("Error al crear el cliente", error);
            setErroRespues(true);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
            aria-describedby="form-dialog-description"
            maxWidth="sm"
            fullWidth
        >
            <DialogContent>
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                    <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        xs={11}
                    >
                        <Typography variant="h6" gutterBottom>
                            Crear Cliente
                        </Typography>
                        <IconButton aria-label="close" onClick={handleClose}>
                            <CancelIcon color='primary' sx={{ fontSize: 30 }} />
                        </IconButton>
                    </Grid>

                    <Grid item xs={11}>
                        <TextField
                            label="Nombre"
                            variant="outlined"
                            fullWidth
                            name="nombre"
                            value={cliente.nombre}
                            onChange={handleChange}
                            required
                        />
                    </Grid>

                    {/* <Grid item xs={12}>
                        <TextField
                            label="Dirección"
                            variant="outlined"
                            fullWidth
                            name="direccion"
                            value={cliente.direccion}
                            onChange={handleChange}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            label="Teléfono"
                            variant="outlined"
                            fullWidth
                            name="telefono"
                            value={cliente.telefono}
                            onChange={handleChange}
                        />
                    </Grid> */}

                    <Grid item xs={11} container justifyContent="flex-end">
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                if (!cliente.nombre.trim()) {
                                    setErrorAlert(true);
                                    return;
                                }
                                crearCliente(cliente);
                            }}
                        >
                            Crear
                        </Button>
                    </Grid>
                </Grid>
            </DialogContent>

            {errorAlert && (
                <AlertError
                    open={errorAlert}
                    setOpen={setErrorAlert}
                    titulo="Error"
                    mensaje="El nombre es obligatorio"
                />
            )}
        </Dialog>
    );
};
